import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ApiWorkItem } from '../lib/api';

export type { ApiWorkItem };

export function useWorkItems(params?: { status?: string; source?: string }) {
  return useQuery({
    queryKey: ['work-items', params?.status ?? null, params?.source ?? null],
    queryFn: () => api.workItems.list(params),
    staleTime: 60 * 1000,
  });
}
